<template>
	<div v-if="transaction">
		<div class="display-1 font-weight-light mb-3">Clone {{transaction.transactionType}}</div>
		<div class="subtitle-1 font-weight-light mb-3"><transaction-type :type="transaction.transactionType" :small="true" /> <span class="code">{{transaction.trackingNumber}}</span></div>

		<v-form>
			<v-row   v-if="transaction.transactionType === 'Analysis'">
				<v-col cols="4">
					<v-text-field readonly label="Application" :value="list(envSettings.Lists.Applications, analysis.applicationId)"></v-text-field>
				</v-col>
				<v-col cols="8"></v-col>
				<v-col cols="4">
					<v-text-field readonly label="Type" :value="list(config.enums.requestTypes, analysis.type)"></v-text-field>
				</v-col>
				<v-col cols="8"></v-col>
				<v-col cols="4">
					<v-text-field readonly label="Format" :value="list(config.enums.requestFormats, analysis.format)"></v-text-field>
				</v-col>
				<v-col cols="8"></v-col>
				<v-col cols="12">
					<v-text-field label="URL" v-model="analysis.url" readonly></v-text-field>
				</v-col>
			</v-row>

			<v-row   v-if="transaction.transactionType === 'Report'">
				<v-col cols="4">
					<v-text-field readonly label="Application" :value="list(envSettings.Lists.Applications, report.applicationId)"></v-text-field>
				</v-col>
				<v-col cols="8"></v-col>
				<v-col cols="4">
					<v-text-field label="Original Analysis Tracking Number" v-model="report.analysisNumber" readonly></v-text-field>
				</v-col>
				<v-col cols="8"></v-col>
				<v-col cols="4">
					<v-text-field readonly label="Output Format" :value="list(config.enums.ReportFormats, report.outputFormat)"></v-text-field>
				</v-col>
				<v-col cols="8"></v-col>
			</v-row>

			<v-row   v-if="transaction.transactionType === 'Pkg'">
				<v-col cols="4">
					<v-text-field readonly label="Application" :value="list(envSettings.Lists.Applications, pkg.applicationId)"></v-text-field>
				</v-col>
				<v-col cols="8"></v-col>
				<v-col cols="4">
					<v-text-field label="Original Analysis Tracking Number" v-model="pkg.analysisNumber" readonly></v-text-field>
				</v-col>
				<v-col cols="8"></v-col>
				<v-col cols="12">
					<v-text-field readonly label="URL" v-model="pkg.url"></v-text-field>
				</v-col>
			</v-row>

			<v-row  >
				<v-col cols="12" v-if="cloneCheck.childrenPass && !cloneCheck.fullPass" class="info--text">
					<v-icon class="info--text">far fa-exclamation-triangle fa-fw</v-icon> Original Analysis will be copied to dev db
				</v-col>
				<v-col cols="12" v-if="!cloneCheck.childrenPass">
					<v-checkbox v-model="syncConfirm" :false-value="null" :true-value="true" color="warning" v-validate.initial="'required'" :error-messages="errors.collect('syncConfirm')" required data-vv-name="syncConfirm">
						<template v-slot:label><v-icon color="warning">far fa-exclamation-triangle fa-fw</v-icon> Sync related data to dev db</template>
					</v-checkbox>
				</v-col>
				<v-col class="pt-3" cols="12" >
					<v-btn @click="submit" color="primary" :disabled="errors.any() || !cloneCheck.childrenPass">Submit</v-btn>
				</v-col>
			</v-row>
		</v-form>
	</div>
</template>

<script>
import api from "../api";
import { requestTypes } from "../enums";
import transactionType from "../components/transactions/transaction-type.vue";
// NOT IN USE

export default {
	components: {
		transactionType,
	},
	data() {
		return {
			transaction: null,
			request: null,
			analysis: {
				applicationId: null,
				format: null,
				type: null,
				url: null,
			},
			report: {
				applicationId: null,
				analysisNumber: null,
				outputFormat: null,
			},
			pkg: {
				applicationId: null,
				analysisNumber: null,
				url: null,
			},
			syncConfirm: null,
			cloneCheck: {
				childrenPass: false,
			},
		};
	},
	created() {
		if (!this.$route.params.trackingNumber) {
			this.$router.push("/");
			return;
		}

		Promise.all([
			api.transaction(this.$route.params.trackingNumber),
			api.transactionRequest(this.$route.params.trackingNumber),
			api.cloneCheck(this.$route.params.trackingNumber),
		]).then((r) => {
			this.transaction = r[0].data;

			this.request = r[1].data[this.transaction.transactionType.toLowerCase()];

			if (this.transaction.transactionType === requestTypes.Analysis) {
				this.analysis = {
					applicationId: this.transaction.applicationId,
					format: this.request.format,
					type: this.request.type,
					url: this.request.url,
				};
			}

			if (this.transaction.transactionType === requestTypes.Report) {
				this.report = {
					applicationId: this.transaction.applicationId,
					analysisNumber: this.request.originalAnalysisTrackingNumber,
					outputFormat: this.request.outputFormat,
				};
			}

			if (this.transaction.transactionType === requestTypes.Pkg) {
				this.pkg = {
					applicationId: this.transaction.applicationId,
					analysisNumber: this.request.originalAnalysisTrackingNumber,
					url: this.request.url,
				};
			}

			this.cloneCheck = r[2].data;
		}, (e) => {
			this.showError(e);
		});
	},
	computed: {},
	methods: {
		submit() {
			const newRequest = {
				sync: this.syncConfirm,
				copyAnalysis: this.cloneCheck.childrenPass && !this.cloneCheck.fullPass,
				type: this.transaction.transactionType,
				originalRequest: this.request,
			};

			console.dir(newRequest);
			// TODO, pass sync + copy original + type
		},
		list(options, value) {
			if (!options || !value) {
				return null;
			}

			return options.find(o => o.Value === value).Key;
		},
	},
};
</script>
